import { Result, BaseResult } from '@hitiq/generic';
import { Observable } from 'rxjs';
import { AmplifyDataStore } from './AmplifyDataStore';
import { DataStoreModel, ModelTypes } from './DataStoreModel';

// TODO: make this Local or DataStore and make a new class GraphQL and another new class REST. Then all of them implement the Persistence interface.
export class Persistance<BackendModel extends DataStoreModel> {
  onCreated: Observable<BackendModel>;
  onUpdated: Observable<BackendModel>;
  onDeleted: Observable<BackendModel>;

  constructor(
    protected readonly datastore: AmplifyDataStore<BackendModel>,
    protected readonly modelType: ModelTypes,
  ) {
    this.onCreated = this.datastore.onObjectCreated(this.modelType);
    this.onUpdated = this.datastore.onObjectUpdated(this.modelType);
    this.onDeleted = this.datastore.onObjectDeleted(this.modelType);
  }

  async create(resource: BackendModel): Promise<Result<BackendModel>> {
    return this.datastore.createObject(resource);
  }

  async update(
    resource: Partial<BackendModel> & Required<DataStoreModel>,
  ): Promise<Result<BackendModel>> {
    return this.datastore.updateObject(resource);
  }

  async delete(dataStoreModel: DataStoreModel): Promise<Result<BackendModel>> {
    return this.datastore.deleteObject(dataStoreModel);
  }

  async getAll(): Promise<Result<BackendModel[]>> {
    return this.datastore.getAll(this.modelType);
  }

  async getById(id: string): Promise<Result<BackendModel>> {
    const result = await this.datastore.getAll(this.modelType);
    const filterResult = new BaseResult<BackendModel>();
    if (result.success) {
      const resource = result.data.find(
        (_resource: BackendModel) => _resource.id === id,
      );
      if (resource) {
        filterResult.data = resource;
        filterResult.success = true;
      } else {
        filterResult.success = false;
        filterResult.error = new Error(`No resource with id ${id} exists.`);
      }
    } else {
      filterResult.success = false;
      filterResult.error = result.error;
    }

    return filterResult;
  }
}
